import { render, staticRenderFns } from "./SaveTileAsTemplateModal.vue?vue&type=template&id=4efab4d8&scoped=true"
import script from "./SaveTileAsTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveTileAsTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SaveTileAsTemplateModal.vue?vue&type=style&index=0&id=4efab4d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efab4d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efab4d8')) {
      api.createRecord('4efab4d8', component.options)
    } else {
      api.reload('4efab4d8', component.options)
    }
    module.hot.accept("./SaveTileAsTemplateModal.vue?vue&type=template&id=4efab4d8&scoped=true", function () {
      api.rerender('4efab4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/SaveTileAsTemplateModal.vue"
export default component.exports